import * as flashActions from 'pkg/actions/flashes';

import * as endpoints from 'pkg/api/endpoints/auto';
import type * as models from 'pkg/api/models';
import { create as modelsCreate } from 'pkg/api/models/actions';
import { crash } from 'pkg/errors/errors';

export interface CreateFormCategoryPayload {
	title: string;
	description: string;
	groupId: number;
}

export const create = async (
	organizationId: number,
	payload: CreateFormCategoryPayload
): Promise<models.formCategory.FormCategory> => {
	const [request, response, error] = await modelsCreate<
		CreateFormCategoryPayload,
		models.formCategory.FormCategory
	>(endpoints.FormCategories.Create(organizationId), payload);

	if (!request.ok) {
		flashActions.show({
			title: crash().title,
			message: error.error,
		});

		return;
	}

	return response;
};
